'use client';

import React__default from 'react';
import { Container, Input, Label } from './Radio.css.js';
import { EAlertType } from '../Utils/constants.js';

var SingleRadio = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.id, id = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.name, name = _e === void 0 ? '' : _e, checked = _a.checked, onChange = _a.onChange, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.width, width = _g === void 0 ? '100%' : _g, _h = _a.isLeftRadio, isLeftRadio = _h === void 0 ? false : _h, _j = _a.alertType, alertType = _j === void 0 ? EAlertType.info : _j, _k = _a.height, height = _k === void 0 ? 36 : _k, 
    // For custom only
    customValue = _a.customValue, _l = _a.isCustomLabel, isCustomLabel = _l === void 0 ? false : _l, decoration = _a.decoration, _m = _a.isHover, isHover = _m === void 0 ? false : _m, _o = _a.isDropdownRadio, isDropdownRadio = _o === void 0 ? false : _o;
    var handleChecked = function () {
        if (disabled)
            return;
        onChange(id);
    };
    var uid = "".concat(id, "-").concat(name, "-radio-button");
    var renderLabel = function () {
        if (customValue)
            return customValue;
        return label ? React__default.createElement(Label, { isDisable: disabled }, typeof label === 'function' ? label() : label) : null;
    };
    return (React__default.createElement(Container, { disabled: disabled, htmlFor: uid, className: className, width: width, notLabel: !label, isLeftRadio: isLeftRadio, height: height, isDropdownRadio: isDropdownRadio, noLabel: label === '', customLabel: isCustomLabel, isHover: isHover, checked: !!checked },
        React__default.createElement(Input, { id: uid, checked: checked, onClick: handleChecked, type: 'radio', disabled: disabled, alertType: alertType, name: name, readOnly: true, isHover: isHover, isDropdownRadio: isDropdownRadio }),
        renderLabel(),
        decoration));
};

export { SingleRadio as default };
//# sourceMappingURL=index.js.map
